(function () {
  function initOne(el) {
    if (el.dataset.isdInitialized === 'true') return;

    var viewport = el.closest('.isd__viewport') || el.parentElement;
    var speed = parseInt(el.dataset.speed, 10) || 800;
    var autoplayDelay = parseInt(el.dataset.autoplay, 10) || 0;
    var slidesMobile = parseFloat(el.dataset.slidesMobile) || 1;
    var slidesDesktop = parseFloat(el.dataset.slidesDesktop) || 1;
    var slideGap = parseInt(el.dataset.slideGap, 10) || 0;
    var centered = el.dataset.centered === 'true';
    var scaleStep = (parseFloat(el.dataset.scaleStep) || 0) / 100;
    var opacityStep = (parseFloat(el.dataset.opacityStep) || 0) / 100;
    var isCoverflow = el.dataset.effect === 'coverflow';
    var coverRotate = parseFloat(el.dataset.rotate);
    var coverDepth = parseFloat(el.dataset.depth);

    var wrapper = el.querySelector('.swiper-wrapper');
    var slideCount = wrapper ? wrapper.querySelectorAll('.swiper-slide').length : 0;
    if (!slideCount) return;

    var maxPerView = Math.ceil(Math.max(slidesMobile, slidesDesktop));
    var useLoop = el.dataset.loop === 'true' && slideCount > 1;
    var realCount = slideCount;

    /* Swiper 11의 loop는 원본 슬라이드가 화면에 보이는 수보다 넉넉해야 동작한다.
       부족하면 루프가 조용히 꺼지므로 원본 세트를 통째로 복제해 채운다.
       세트 단위로만 복제하므로 realIndex % realCount로 원본 위치를 되찾을 수 있고,
       페이지 점은 아래에서 원본 개수만큼만 직접 만든다.

       주의: loopAdditionalSlides를 크게 잡으면 (보이는 수 + 추가분)이 전체의 절반을
       넘어 Swiper가 루프를 포기하고 끝에서 멈춘다. 추가분은 1로 두고 대신
       전체 슬라이드 수를 2 * (보이는 수 + 추가분) + 2 이상으로 확보한다. */
    var loopAdditional = 1;
    if (useLoop) {
      var minNeeded = Math.max(realCount * 2, 2 * (maxPerView + loopAdditional) + 2);
      var originals = Array.prototype.slice.call(wrapper.querySelectorAll('.swiper-slide'));
      while (wrapper.querySelectorAll('.swiper-slide').length < minNeeded) {
        for (var c = 0; c < originals.length; c++) {
          wrapper.appendChild(originals[c].cloneNode(true));
        }
      }
    }

    var config = {
      speed: speed,
      loop: useLoop,
      loopAdditionalSlides: useLoop ? loopAdditional : 0,
      threshold: 10,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      slidesPerView: slidesMobile,
      spaceBetween: slideGap,
      centeredSlides: centered,
      centerInsufficientSlides: !useLoop,
      breakpoints: {
        750: {
          slidesPerView: slidesDesktop,
          spaceBetween: slideGap,
          centeredSlides: centered,
        },
      },
    };

    if (isCoverflow) {
      /* 입체 효과. 양옆 카드가 안쪽으로 눕기 때문에 가로가 세로보다 더 많이 줄어든다.
         Swiper가 슬라이드 transform과 겹침 순서를 직접 다루므로 아래 축소 로직은 쓰지 않는다. */
      config.effect = 'coverflow';
      config.coverflowEffect = {
        rotate: isNaN(coverRotate) ? 34 : coverRotate,
        depth: isNaN(coverDepth) ? 100 : coverDepth,
        stretch: 0,
        modifier: 1,
        scale: 1,
        slideShadows: false,
      };
    } else {
      /* 가운데에서 한 칸 멀어질 때마다 단계적으로 축소·반투명 처리.
         slide.progress는 가운데 기준 슬라이드 단위 거리(0, ±1, ±2 ...)다.
         축소·투명도를 쓰지 않더라도 겹침 순서(z-index)를 위해 항상 적용한다. */
      var applyDepth = function (sw) {
        for (var i = 0; i < sw.slides.length; i++) {
          var slide = sw.slides[i];
          var depth = Math.min(Math.abs(slide.progress || 0), 4);
          var scale = Math.max(1 - scaleStep * depth, 0.2);
          var opacity = Math.max(1 - opacityStep * depth, 0);
          slide.style.transform = 'scale(' + scale + ')';
          slide.style.opacity = String(opacity);
          /* 가운데 카드가 양옆 위로 겹쳐 보이도록 */
          slide.style.zIndex = String(100 - Math.round(depth * 10));
        }
      };

      config.on = {
        init: applyDepth,
        progress: applyDepth,
        setTransition: function (sw, duration) {
          for (var i = 0; i < sw.slides.length; i++) {
            sw.slides[i].style.transitionDuration = duration + 'ms';
            sw.slides[i].style.transitionProperty = 'transform, opacity';
          }
        },
      };
    }

    if (autoplayDelay > 0) {
      config.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    var prevEl = viewport ? viewport.querySelector('.isd__arrow--prev') : null;
    var nextEl = viewport ? viewport.querySelector('.isd__arrow--next') : null;
    if (prevEl && nextEl) {
      config.navigation = { prevEl: prevEl, nextEl: nextEl };
    }

    var instance = new Swiper(el, config);
    el.dataset.isdInitialized = 'true';

    /* 페이지 점은 Swiper에 맡기지 않고 원본 이미지 개수만큼만 직접 만든다.
       (loop용 복제 슬라이드가 점으로 잡히는 것을 막기 위함) */
    var paginationEl = viewport ? viewport.querySelector('.isd__pagination') : null;
    if (paginationEl && realCount > 1) {
      var bullets = [];

      var syncBullets = function () {
        var current = instance.realIndex % realCount;
        for (var b = 0; b < bullets.length; b++) {
          var isActive = b === current;
          bullets[b].classList.toggle('is-active', isActive);
          bullets[b].setAttribute('aria-current', isActive ? 'true' : 'false');
        }
      };

      for (var n = 0; n < realCount; n++) {
        var bullet = document.createElement('button');
        bullet.type = 'button';
        bullet.className = 'isd__bullet';
        bullet.setAttribute('aria-label', n + 1 + '번째 이미지로 이동');
        bullet.dataset.index = String(n);
        bullet.addEventListener('click', function () {
          var target = parseInt(this.dataset.index, 10);
          if (instance.slideToLoop) {
            instance.slideToLoop(target);
          } else {
            instance.slideTo(target);
          }
        });
        paginationEl.appendChild(bullet);
        bullets.push(bullet);
      }

      instance.on('slideChange', syncBullets);
      syncBullets();
    }

    /* 이미지 lazy-load 완료 후 레이아웃/루프 재계산 */
    el.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () {
        if (instance && instance.update) instance.update();
      });
    });
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-image-slider-dissolve]').forEach(initOne);
  }

  function boot() {
    if (typeof Swiper === 'undefined') {
      /* theme.liquid의 Swiper가 defer 로드되므로 준비될 때까지 대기 */
      window.setTimeout(boot, 50);
      return;
    }
    initAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* 테마 에디터에서 섹션을 다시 그릴 때 재초기화 */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
